import revive_payload_client_4sVQNw7RlN from "/home/denis/sources/nova-plateform-web/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/denis/sources/nova-plateform-web/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/denis/sources/nova-plateform-web/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/denis/sources/nova-plateform-web/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/denis/sources/nova-plateform-web/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/denis/sources/nova-plateform-web/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/denis/sources/nova-plateform-web/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_WLsn00x1qh from "/home/denis/sources/nova-plateform-web/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import slideovers_LDumGYo2KH from "/home/denis/sources/nova-plateform-web/node_modules/@nuxt/ui/dist/runtime/plugins/slideovers.mjs";
import modals_bidRKewKK5 from "/home/denis/sources/nova-plateform-web/node_modules/@nuxt/ui/dist/runtime/plugins/modals.mjs";
import colors_244lXBzhnM from "/home/denis/sources/nova-plateform-web/node_modules/@nuxt/ui/dist/runtime/plugins/colors.mjs";
import plugin_client_i8AMfKeYnY from "/home/denis/sources/nova-plateform-web/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.mjs";
import chunk_reload_client_UciE0i6zes from "/home/denis/sources/nova-plateform-web/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import vue_easy_lightbox_client_lWqeizDQUL from "/home/denis/sources/nova-plateform-web/plugins/vue-easy-lightbox.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_WLsn00x1qh,
  slideovers_LDumGYo2KH,
  modals_bidRKewKK5,
  colors_244lXBzhnM,
  plugin_client_i8AMfKeYnY,
  chunk_reload_client_UciE0i6zes,
  vue_easy_lightbox_client_lWqeizDQUL
]